<!--站点一览列表-->
<template>
  <div>
    <div class="content-header">
      <div class="left">
         <span class="title">案例编辑/新增</span>
      </div>
    </div>
    <Form :label-width="100">
      <Row>
        <Col span="12">
          <FormItem label="案例名称">
            <Input v-model="formItem.name" placeholder="案例名称,16字以内"></Input>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="权重">
            <Input v-model="formItem.solt" placeholder="整数，数值越大显示越靠前"></Input>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="12">
          <FormItem label="描述">
            <Input
              v-model="formItem.des"
              type="textarea"
              :autosize="{minRows: 2,maxRows: 5}"
              placeholder="60字以内简短描述"
            />
          </FormItem>
        </Col>
        <Col span="12">
          <Col span="12">
            <FormItem label="logo">
              <Upload
                multiple
                type="drag"
                :action="baseUrl + '/site/admin/upload'"
                :multiple="false"
                :max-size="1024"
                :on-success="uploadSuccess"
                :on-error="uploadError"
                :on-exceeded-size="uploadSize"
                :default-file-list="upload.logo"
                :format="['jpg','png','jpeg']"
              >
                <div style="padding: 20px 0">
                  <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                  <p>点击或拖拽上传</p>
                </div>
              </Upload>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="预览图">
              <Upload
                multiple
                type="drag"
                :action="baseUrl + '/site/admin/upload'"
                :multiple="false"
                :max-size="1024"
                :on-success="uploadSuccess1"
                :on-error="uploadError"
                :on-exceeded-size="uploadSize"
                :default-file-list="upload.p"
                :format="['jpg','png','jpeg']"
              >
                <div style="padding: 20px 0">
                  <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                  <p>点击或拖拽上传</p>
                </div>
              </Upload>
            </FormItem>
          </Col>
        </Col>
      </Row>
      <Row>
        <FormItem label="详情">
          <vue-editor v-model="formItem.text" useCustomImageHandler @imageAdded="handleImageAdded"></vue-editor>
        </FormItem>
      </Row>
      <FormItem label>
        <Button type="success" @click="save" :loading="loading">保存</Button>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { VueEditor } from 'vue2-editor'
import config from '@/config'

export default {
  components: { VueEditor },
  data () {
    return {
      formItem: {
        name: '',
        des: '',
        text: '',
        solt: '',
        is_del: 0,
        preview: '',
        logo: '',
        id: 0
      },
      upload: {
        logo: [],
        p: []
      },
      loading: false,
      baseUrl: ''
    }
  },
  methods: {
    ...mapActions(['WebGetCase', 'WebSaveCase', 'ImagesUpload']),
    getData () {
      this.WebGetCase({ id: this.formItem.id }).then(res => {
        this.formItem = res.data[0]
        this.upload.logo.push({
          name: 'logo',
          url: res.data[0].logo
        })
        this.upload.p.push({
          name: '预览图',
          url: res.data[0].preview
        })
        console.log(this.upload)
      })
    },
    handleImageAdded (file, Editor, cursorLocation) {
      if (file.size > 800 * 1024) {
        this.$Message.warning({
          content: `图片过大(${
            file.name
          }),为避免用户加载时间过长,推荐裁剪后再编辑`,
          duration: 5
        })
        return false
      }
      var formData = new FormData()
      formData.append('file', file)
      this.ImagesUpload(formData).then(res => {
        if (res.code === 1) { Editor.insertEmbed(cursorLocation, 'image', config.imgSrc + res.path) }
      })
    },
    uploadSuccess (response, file, fileList) {
      this.formItem.logo = response.path
    },
    uploadSuccess1 (response, file, fileList) {
      this.formItem.preview = response.path
    },
    uploadError (e) {
      this.$Message.warning({
        content: `文件上传失败`,
        duration: 5
      })
    },
    uploadSize (e) {
      this.$Message.warning({
        content: `图片过大(${
          file.name
        }),为避免用户加载时间过长,推荐裁剪后再编辑`,
        duration: 5
      })
    },
    save () {
      this.loading = true
      console.log(this.formItem)
      this.WebSaveCase(this.formItem).then(res => {
        this.$Message.success(res.msg)
        setTimeout(() => {
          this.$router.back()
        }, 1500)
      })
    }
  },
  mounted () {
    this.formItem.id = this.$route.query.id
    if (this.formItem.id && this.formItem.id > 0) this.getData()
  },
  created () {
    this.baseUrl =
      process.env.NODE_ENV === 'development'
        ? config.baseUrl.dev
        : config.baseUrl.pro
  },
  computed: mapGetters({
    user: 'agent',
    access: 'access'
  })
}
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
